import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const { signIn } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-brand-50 to-slate-100">
      <form
        className="w-full max-w-sm bg-white rounded-xl shadow p-8 space-y-4"
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true); setErr(null);
          const { error } = await signIn(email, pwd);
          setBusy(false);
          if (error) setErr(error);
          else nav('/dashboard');
        }}
      >
        <h1 className="text-2xl font-semibold text-brand-700 text-center">CRM Clínica</h1>
        <p className="text-sm text-slate-500 text-center -mt-2">Acesso restrito</p>
        <input type="email" required placeholder="email" value={email} onChange={e => setEmail(e.target.value)}
          className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm" />
        <input type="password" required placeholder="senha" value={pwd} onChange={e => setPwd(e.target.value)}
          className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm" />
        {err && <p className="text-sm text-red-600">{err}</p>}
        <button type="submit" disabled={busy}
          className="w-full bg-brand-500 hover:bg-brand-600 text-white py-2 rounded-md font-medium disabled:opacity-60">
          {busy ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
